/**
 * CoureHub.Broadcast.Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DeliveryStatus = 1 | 2 | 4;

export const DeliveryStatus = {
    NUMBER_1: 1 as DeliveryStatus,
    NUMBER_2: 2 as DeliveryStatus,
    NUMBER_4: 4 as DeliveryStatus
};